export default {"src":"/_next/static/media/sportbeleid.81c9998d.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};